module.exports = __webpack_public_path__ + "img/20200116154904689.50bf5e6f.jpg";